/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowApiControllersPlanningPlanningWeeksControllerPlanEntryDto
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getPlanningWeeks = () => {
const getApiV1PlanningWeeksYearWeek = (
    year: number,
    week: number,
 options?: SecondParameter<typeof customInstance<FacilityFlowApiControllersPlanningPlanningWeeksControllerPlanEntryDto[]>>,) => {
      return customInstance<FacilityFlowApiControllersPlanningPlanningWeeksControllerPlanEntryDto[]>(
      {url: `/api/v1/planning/weeks/${year}/${week}`, method: 'GET'
    },
      options);
    }
  return {getApiV1PlanningWeeksYearWeek}};
export type GetApiV1PlanningWeeksYearWeekResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningWeeks>['getApiV1PlanningWeeksYearWeek']>>>
